let generation = 0
const emitted = new Set<string>()

export const currentBridgeGeneration = (): number => generation

export const resetBridgeEvents = (): void => {
  generation += 1
  emitted.clear()
}

export const claimBridgeEvent = (key?: string): string | null => {
  if (key !== undefined) {
    if (emitted.has(key)) return null
    emitted.add(key)
  }
  return `${generation}:${crypto.randomUUID()}`
}
